import { route } from "navi"
import React from "react"
import { getQueryValueFromCurrentUrl, ETermsType } from "swiipe.portal.shared"
import TermsTextPage from "../pages/TermsTextPage"
import { disableForEnvSandbox, enableOnlyForEnvSandbox, getRouteIncludingEnv } from "../services/routesService"
import { TUserRelation } from "../type/TUserRelation"

export const legalRoutes = {
    "/terms": getRouteIncludingEnv(
        <TermsTextPage
            userRelationType={getQueryValueFromCurrentUrl("relationType") as TUserRelation}
            userRelationId={getQueryValueFromCurrentUrl("relationId") ?? undefined}
            termsType={getQueryValueFromCurrentUrl("termsType") as ETermsType}
        />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_end_user": getRouteIncludingEnv(
        <TermsTextPage userRelationType="User" termsType="TermsUser" />,
        disableForEnvSandbox
    ),
    "/privacy_policy_end_user": getRouteIncludingEnv(
        <TermsTextPage userRelationType="User" termsType="PrivacyPolicyShared" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_merchant": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsMerchant" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_merchant_sandbox": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsMerchant" />,
        enableOnlyForEnvSandbox
    ),
    "/privacy_policy_merchant": route({
        view: <TermsTextPage userRelationType="Merchant" termsType="PrivacyPolicyShared" />,
    }),
    "/privacy_policy": route({
        view: <TermsTextPage userRelationType="User" termsType="PrivacyPolicyShared" />,
    }),
    "/data_processing_terms": route({
        view: <TermsTextPage userRelationType="User" termsType="DataProcessingAgreement" />,
    }),
    "/merchant_partner_agreement": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="MerchantPartnerAgreement" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_partner": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Partner" termsType="TermsPartner" />,
        disableForEnvSandbox
    ),
    "/privacy_policy_partner": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Partner" termsType="PrivacyPolicyShared" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_psp": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsPSP" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_a2a": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsA2a" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_acquiring": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsAcquiringClearhaus" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_payfaq_digiteal": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsPayFaqDigiteal" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_mobilepay_online": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType={"TermsMobilePayOnline"} />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_dankort": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsDankort" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_forbrugsforeningen": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsForbrugsforeningen" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_winback": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsWinBack" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_plus_sell": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsPlusSell" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_anywhere_mobile": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsAnywhereMobile" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_return_sell": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsReturnSell" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_viabill": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsViaBill" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_anyday": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsAnyday" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_bancontact": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsBancontact" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_ideal": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsIdeal" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_termstech": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsTermsTech" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_applepay": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsApplePay" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_vipps_psp": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsVippsPsp" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_vipps_epayment": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsVippsEpayment" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_klarna": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsKlarna" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_swish": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsSwish" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_resurs": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsResurs" />,
        disableForEnvSandbox
    ),
    "/terms_and_conditions_external_analytics": getRouteIncludingEnv(
        <TermsTextPage userRelationType="Merchant" termsType="TermsExternalAnalytics" />,
        disableForEnvSandbox
    ),
}
